/* WOLVESHOP — comportamiento de marca: nombre en la manga (+$50), "Completa tu kit" en el carrito y barra fija de compra. */
(function () {
  const raiz = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

  async function agrega(items, conSecciones) {
    const cuerpo = { items };
    if (conSecciones) cuerpo.sections = 'cart-drawer,cart-icon-bubble';
    const r = await fetch(raiz + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(cuerpo),
    });
    if (!r.ok) throw new Error('cart/add ' + r.status);
    return r.json();
  }

  /* ---------- Nombre en la manga ---------- */
  document.addEventListener('change', (e) => {
    const caja = e.target.closest('[data-ws-manga-check]');
    if (!caja) return;
    const bloque = caja.closest('.ws-manga');
    bloque.classList.toggle('is-on', caja.checked);
    if (caja.checked) bloque.querySelector('input[type="text"]').focus();
  });

  document.addEventListener(
    'submit',
    async (e) => {
      const form = e.target;
      if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
      const bloque = document.querySelector('.ws-manga.is-on');
      if (!bloque || form.dataset.wsMangaListo === '1') return;
      const nombre = bloque.querySelector('input[type="text"]').value.trim().toUpperCase();
      if (!nombre) {
        e.preventDefault();
        e.stopImmediatePropagation();
        bloque.querySelector('input[type="text"]').focus();
        bloque.querySelector('.ws-manga__nota').textContent = 'Escribe el nombre o número que va en la manga.';
        return;
      }
      e.preventDefault();
      e.stopImmediatePropagation();
      let oculto = form.querySelector('input[name="properties[Nombre en la manga]"]');
      if (!oculto) {
        oculto = document.createElement('input');
        oculto.type = 'hidden';
        oculto.name = 'properties[Nombre en la manga]';
        form.appendChild(oculto);
      }
      oculto.value = nombre;
      try {
        const playera = document.querySelector('.product__title h1, .product__title h2');
        await agrega(
          [
            {
              id: Number(bloque.dataset.variante),
              quantity: 1,
              properties: { 'Nombre en la manga': nombre, Playera: playera ? playera.textContent.trim() : '' },
            },
          ],
          false,
        );
      } catch (err) {
        bloque.querySelector('.ws-manga__nota').textContent =
          'No se pudo agregar la personalización; intenta de nuevo.';
        return;
      }
      form.dataset.wsMangaListo = '1';
      (form.querySelector('[type="submit"]') || form).click();
      setTimeout(() => {
        form.dataset.wsMangaListo = '';
      }, 1500);
    },
    true,
  );

  /* ---------- Completa tu kit ---------- */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-ws-kit]');
    if (!btn) return;
    e.preventDefault();
    btn.setAttribute('aria-busy', 'true');
    try {
      const res = await agrega([{ id: Number(btn.dataset.wsKit), quantity: 1 }], true);
      const cajon = document.querySelector('cart-drawer');
      if (cajon && res.sections) cajon.renderContents({ id: btn.dataset.wsKit, sections: res.sections });
      else location.href = raiz + 'cart';
    } catch (err) {
      btn.textContent = 'Intenta de nuevo';
    } finally {
      btn.removeAttribute('aria-busy');
    }
  });

  /* ---------- Barra fija de compra (celular) ---------- */
  function barraFija() {
    const fija = document.querySelector('.ws-fija');
    const real = document.querySelector('product-form [type="submit"]');
    if (!fija || !real) return;
    new IntersectionObserver(([entrada]) => {
      const debajo = entrada.boundingClientRect.top < 0;
      fija.classList.toggle('is-visible', !entrada.isIntersecting && debajo);
    }).observe(real);
    fija.querySelector('button').addEventListener('click', () => {
      real.scrollIntoView({ behavior: 'smooth', block: 'center' });
      real.click();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', barraFija);
  else barraFija();
})();

/* ---------- Movimiento extra (v2): aparicion al scroll, inclinacion 3D, paralaje y botones magneticos ---------- */
(function () {
  const quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fino = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  // Aparicion escalonada
  const obs =
    'IntersectionObserver' in window && !quieto
      ? new IntersectionObserver(
          (es) => {
            es.forEach((e) => {
              if (e.isIntersecting) {
                e.target.classList.add('is-in');
                obs.unobserve(e.target);
              }
            });
          },
          { threshold: 0.15, rootMargin: '0px 0px -8% 0px' },
        )
      : null;
  document.querySelectorAll('[data-ws-reveal]').forEach((el) => {
    el.querySelectorAll('[data-ws-paso]').forEach((h, i) => h.style.setProperty('--d', i));
    if (obs) obs.observe(el);
    else el.classList.add('is-in');
  });
  if (quieto) return;

  // Inclinacion 3D de las tarjetas de coleccion
  if (fino)
    document.querySelectorAll('.ws-col').forEach((c) => {
      c.addEventListener('pointermove', (e) => {
        const r = c.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width;
        const y = (e.clientY - r.top) / r.height;
        c.style.transform = 'rotateY(' + (x - 0.5) * 10 + 'deg) rotateX(' + (0.5 - y) * 10 + 'deg)';
        c.style.setProperty('--mx', x * 100 + '%');
        c.style.setProperty('--my', y * 100 + '%');
      });
      c.addEventListener('pointerleave', () => {
        c.style.transform = '';
      });
    });

  // Paralaje de la foto de portada
  const img = document.querySelector('.ws-hero__media img');
  if (img) {
    let pedido = false;
    window.addEventListener(
      'scroll',
      () => {
        if (pedido) return;
        pedido = true;
        requestAnimationFrame(() => {
          img.style.translate = '0 ' + Math.min(window.scrollY, 900) * 0.18 + 'px';
          pedido = false;
        });
      },
      { passive: true },
    );
  }

  // Botones magneticos
  if (fino)
    document.querySelectorAll('.ws-btn').forEach((b) => {
      b.addEventListener('pointermove', (e) => {
        const r = b.getBoundingClientRect();
        b.style.transform =
          'translate(' +
          (e.clientX - r.left - r.width / 2) * 0.18 +
          'px, ' +
          (e.clientY - r.top - r.height / 2) * 0.3 +
          'px)';
      });
      b.addEventListener('pointerleave', () => {
        b.style.transform = '';
      });
    });
})();

/* ---------- Movimiento v3 ---------- */
(function () {
  const quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fino = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (quieto) return;

  // Barra de progreso de lectura + encabezado compacto + cinta que acelera con la velocidad del scroll
  const barra = document.createElement('div'); barra.className = 'ws-progreso'; document.body.appendChild(barra);
  const pistas = [...document.querySelectorAll('.ws-cinta__pista')];
  let ultimoY = window.scrollY, ultimoT = performance.now(), pedido = false;
  window.addEventListener('scroll', () => {
    if (pedido) return; pedido = true;
    requestAnimationFrame(() => {
      const alto = document.documentElement.scrollHeight - innerHeight;
      barra.style.transform = 'scaleX(' + (alto > 0 ? scrollY / alto : 0) + ')';
      document.body.classList.toggle('ws-compacto', scrollY > 80);
      const ahora = performance.now(); const vel = Math.abs(scrollY - ultimoY) / Math.max(16, ahora - ultimoT);
      ultimoY = scrollY; ultimoT = ahora;
      pistas.forEach((p) => p.getAnimations().forEach((a) => { a.playbackRate = Math.min(5, 1 + vel * 3); }));
      clearTimeout(window.__wsFrena); window.__wsFrena = setTimeout(() => pistas.forEach((p) => p.getAnimations().forEach((a) => { a.playbackRate = 1; })), 160);
      pedido = false;
    });
  }, { passive: true });

  // Texto que se descifra (sello de la portada)
  const signos = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789#%&*';
  document.querySelectorAll('[data-ws-descifra]').forEach((el) => {
    const final = el.textContent; let paso = 0; const total = final.length + 12;
    const tic = setInterval(() => {
      el.textContent = final.split('').map((c, i) => (c === ' ' || i < paso - 12 ? c : signos[Math.floor(Math.random() * signos.length)])).join('');
      if (++paso > total) { clearInterval(tic); el.textContent = final; }
    }, 35);
  });

  // Cursor propio que crece sobre enlaces y botones
  if (fino) {
    const cur = document.createElement('div'); cur.className = 'ws-cursor is-oculto'; document.body.appendChild(cur);
    let x = 0, y = 0, cx = 0, cy = 0;
    window.addEventListener('pointermove', (e) => { x = e.clientX; y = e.clientY; cur.classList.remove('is-oculto'); }, { passive: true });
    document.addEventListener('pointerleave', () => cur.classList.add('is-oculto'));
    document.addEventListener('pointerover', (e) => cur.classList.toggle('is-link', !!e.target.closest('a, button, label, .ws-col')));
    (function sigue() { cx += (x - cx) * 0.2; cy += (y - cy) * 0.2; cur.style.transform = 'translate(' + cx + 'px,' + cy + 'px)'; requestAnimationFrame(sigue); })();
  }

  // La playera vuela al carrito al agregarla
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('product-form [type="submit"], [data-ws-kit]');
    if (!btn) return;
    const item = btn.closest('.ws-kit__item');
    const foto = (item && item.querySelector('img')) || document.querySelector('.product__media-item img, .product__media img');
    const carrito = document.querySelector('#cart-icon-bubble');
    if (!foto || !carrito) return;
    const a = foto.getBoundingClientRect(); const b = carrito.getBoundingClientRect();
    const clon = foto.cloneNode(); clon.className = 'ws-vuela'; clon.removeAttribute('srcset'); clon.src = foto.currentSrc || foto.src;
    Object.assign(clon.style, { left: a.left + 'px', top: a.top + 'px', width: a.width + 'px', height: a.height + 'px' });
    document.body.appendChild(clon);
    requestAnimationFrame(() => {
      const s = 40 / a.width;
      clon.style.transform = 'translate(' + (b.left + b.width / 2 - a.left - a.width / 2) + 'px,' + (b.top + b.height / 2 - a.top - a.height / 2) + 'px) scale(' + s + ') rotate(-12deg)';
      clon.style.opacity = '0.2';
    });
    setTimeout(() => { clon.remove(); carrito.classList.remove('ws-brinca'); void carrito.offsetWidth; carrito.classList.add('ws-brinca'); }, 850);
  }, true);
})();
